<template>
    <div>
        <PreLoader v-if="isLoading"/>
        <SuperAdminSchoolHead>
            <template v-slot:title>{{ $t('subject') }}</template>
        </SuperAdminSchoolHead>
        <div class="scl-ad">
            <SmartTable :schools="adminCourses" :total-elements="totalElements" :current-page="currentPage"
                        :page-size="pageSize" :totalPages="totalPages" @leftClick="onLeftClick"
                        @rightClick="onRightClick">
                <template v-slot:head>
                    <th class="top-th">ID</th>
                    <th v-html="$t('title1') "/>
                    <th>Код</th>
                </template>
                <template v-slot:body="{item}">
                    <td v-html="item['id']"/>
                    <td v-html="$root.$i18n.locale === 'kg' ? item['courseTitleKG'] : item['courseTitleRU'] + ' ' + item['title']"/>
                    <td v-html="item['code']" :class="{'added': item['disable']}"/>
                </template>
            </SmartTable>
        </div>
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import { AdminCourseService } from '@/_services/admin-course.service'
import { CourseService } from '@/_services/course.service'
import PreLoader from '@/components/preloader/PreLoader'
const courseService = new CourseService()
const adminCourseService = new AdminCourseService()

export default {
    name: 'SchoolAdminCourses',
    components: {SuperAdminSchoolHead, SmartTable, PreLoader},
    data: () => ({
        isLoading: false,
        items: [],
        adminCourses: [],
        totalElements: 0,
        pageSize: 0,
        currentPage: 1,
        totalPages: 1,
        isAddUser: false,
        itemsSelected: 0
    }),
    computed: {
        userProfile () {
            return this.$store.state.account.profile
        }
    },
    created () {
        this.fetchCourses(0)
    },
    methods: {
        onLeftClick () {
            this.currentPage--
            this.fetchCourses(this.currentPage - 1)
        },
        onRightClick () {
            this.currentPage++
            this.fetchCourses(this.currentPage - 1)
        },
        fetchCourses (page) {
            this.isLoading = true
            courseService.listBySchool(this.userProfile.schools[0].id)
                .then((res) => {
                    this.items = res.content
                    return adminCourseService.list('', page, 10)
                })
                .then((res) => {
                    this.totalElements = res.totalElements
                    this.totalPages = res.totalPages
                    this.currentPage = res.number + 1
                    this.adminCourses = res.content.map(i => {
                        if (this.items.some(it => it.adminCourseId === i.id)) i.disable = true
                        return i
                    }).sort((a, b) => a.title.localeCompare(b.title))
                    this.isLoading = false
                })
                .catch((err) => {
                    this.$toast.error(err)
                    this.isLoading = false
                })
        }
    }
}
</script>
